import { useState } from 'react';
import { Bot, ImageIcon, ScanText } from 'lucide-react';
import { LLMConfigPage } from '@/pages/LLMConfigPage';
import { OCRConfigPage } from '@/pages/OCRConfigPage';
import { ImageEditConfigPage } from '@/pages/ImageEditConfigPage';

type InstanceTab = 'llm' | 'ocr' | 'image';
const tabs = [
    { id: 'llm' as const, label: 'LLM 实例', icon: Bot },
    { id: 'ocr' as const, label: 'OCR 实例', icon: ScanText },
    { id: 'image' as const, label: 'AI 生图实例', icon: ImageIcon },
];

export function InstanceManagementPage() {
    const [activeTab, setActiveTab] = useState<InstanceTab>('llm');
    return (
        <div className="flex h-full flex-col">
            <header className="shrink-0 border-b border-zinc-200 bg-white px-4 py-3">
                <h1 className="text-base font-semibold text-zinc-900">实例管理</h1>
                <p className="text-xs text-zinc-500">统一管理 LLM、OCR 和 AI 生图接口实例</p>
                <div className="mt-3 inline-flex rounded-md border border-zinc-200 bg-zinc-100 p-1">
                    {tabs.map(tab => {
                        const Icon = tab.icon;
                        return <button key={tab.id} type="button" onClick={() => setActiveTab(tab.id)} className={`inline-flex items-center gap-1.5 rounded px-4 py-1.5 text-xs font-medium ${activeTab === tab.id ? 'bg-[#159b96] text-white shadow-sm' : 'text-zinc-600 hover:text-zinc-900'}`}><Icon size={14} />{tab.label}</button>;
                    })}
                </div>
            </header>
            <div className="min-h-0 flex-1">
                {activeTab === 'llm' && <LLMConfigPage embedded />}
                {activeTab === 'ocr' && <OCRConfigPage embedded />}
                {activeTab === 'image' && <ImageEditConfigPage embedded instancesOnly />}
            </div>
        </div>
    );
}
